<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <!-- 表单查询 -->
    <div class="pdt-15 pdb-15 bg-white">
      <el-form ref="form" :model="form" label-width="90px" inline>
        <el-form-item label="合伙人姓名">
          <el-input
            v-model="form.userName"
            placeholder="请输入合伙人姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="合伙人电话">
          <el-input
            v-model="form.userPhone"
            placeholder="请输入合伙人电话"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="form.status" clearable placeholder="全部">
            <el-option label="已通过" value="2"></el-option>
            <el-option label="已驳回" value="3"></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="待提交" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维护人员" prop="staffId">
          <el-select v-model="form.staffId" placeholder="请选择维护人员">
            <el-option
              v-for="(v, i) in people"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList()">查 询</el-button>
          <el-button
            @click="
              form = {};
              getList();
            "
            >重 置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-table
      class="mgt-15"
      :data="tableData"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="applyNum" label="申请编号"> </el-table-column>
      <el-table-column prop="partnerNum" label="合伙人编号"> </el-table-column>
      <el-table-column prop="userName" label="合伙人姓名"> </el-table-column>
      <el-table-column prop="userPhone" label="合伙人电话"> </el-table-column>
      <el-table-column prop="staffName" label="维护人员"> </el-table-column>
      <el-table-column prop="status" label="审核状态">
        <template slot-scope="scope">
          <span style="color: var(--accent)" v-if="scope.row.status === 0"
            >待提交</span
          >
          <span style="color: #E6A23C" v-else-if="scope.row.status === 1"
            >待审核</span
          >
          <span style="color: #67C23A" v-else-if="scope.row.status === 2"
            >已通过</span
          >
          <span style="color: var(--danger)" v-else-if="scope.row.status === 3"
            >已驳回</span
          >
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="申请时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            v-if="[1, 3].includes(scope.row.status)"
            type="text"
            size="small"
            @click="handleDetail(scope.row)"
            >详情</el-button
          >
          <span v-if="scope.row.status == 2">- -</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      form: {},
      people: [],
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50 // 数据总条数
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    }
  },
  created() {
    this.getList();
    this.getPeoplePull();
  },
  methods: {
    // 列表
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.partner
        .applyList({
          pageNum: this.page,
          pageSize: this.pageSize,
          userName: this.form.userName,
          userPhone: this.form.userPhone,
          status: this.form.status,
          staffId: this.form.staffId,
          startTime: this.form.startTime,
          endTime: this.form.endTime
        })
        .then(res => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    getPeoplePull() {
      this.$api.partner.weihuPeoplePull().then(res => {
        if (res.code === 200) {
          this.people = res.data.list;
        }
      });
    },
    handleDetail(row) {
      this.$router.push({
        path: "/partner/partnerApply/partnerApplyDetail",
        query: {
          id: row.id,
          status: row.status
        }
      });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    }
  }
};
</script>

<style lang="scss" scoped></style>
